
module.exports = function getResource(label, vars = []) {
    let resources = {
        backToLists: 'Back to Lists'
    };
    return resources[label];
};
